import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import EntitiesTableViews from 'components/organisms/TableViews/EntitiesTableViews/EntitiesTableViews';

const StyledDatabaseEntitiesTableViews = styled(EntitiesTableViews)`
  ${ComponentStyles}
`;

StyledDatabaseEntitiesTableViews.propTypes = {
  theme: PropTypes.object
};

export default StyledDatabaseEntitiesTableViews;
